import { UsersFragment } from '@/graphql/queries/User.query';
import type { ZnglyContext_Backend_Query$data } from '@/graphql/queries/ZnglyContext.query';
import type { Users_Fragment$key } from '@/graphql/queries/__generated__/Users_Fragment.graphql';
import { useRelayStore } from '@/graphql/useRelayStore';
import { useEffect } from 'react';
import { useFragment } from 'react-relay';

export type UserNode = {
  id: string;
  username: string;
  name: string;
};

const useUserLoader = (fragmentData: ZnglyContext_Backend_Query$data): UserNode[] => {
  const { users } = useFragment<Users_Fragment$key>(UsersFragment, fragmentData);

  useEffect(() => {
    if (!users?.__id) return;

    useRelayStore.getState().set__id('Users_Management_Fragment', users?.__id);
  }, [users?.__id]);

  const userMap = (users?.edges || [])
    .filter((user) => !!user?.node?.id && user?.node?.role !== 'api' && user?.node?.username !== 'analytics')
    .map(({ node: { id, username, name } }) => ({ id, username: username ?? '', name: name ?? '' }));

  return userMap;
};

export default useUserLoader;
